var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-date-picker',{attrs:{"full-width":"","color":"primary","show-current":_vm.showCurrent,"no-title":"","locale":"fr","range":"","events":_vm.showEvents},on:{"input":_vm.handleFilter},model:{value:(_vm.dates),callback:function ($$v) {_vm.dates=$$v},expression:"dates"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }